import { createElement } from 'react';
import { render } from 'react-dom';

import { App } from './App';
import loader from './loader';
import { Configurations } from './model/api';

if (process.env.NODE_ENV === 'development') {
  // Must use require here as import statements are only allowed
  // to exist at top-level.
  // eslint-disable-next-line global-require
  // require('preact/debug');
}

/**
 * Default configurations that are overridden by
 * parameters in embedded script.
 */
const defaultConfig: Configurations = {
  clientId: '',
  disableDarkMode: false,
  isPreview: false,
};

// main entry point - calls loader and render Preact app into supplied element
loader(window, defaultConfig, window.document.currentScript, (el, config) => {
  render(createElement(App, { root: el, config: config }), el);
});
